import { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";

const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL ||
  "https://new-backend-production.apps.konnectbd.com";

export default function useWalletSocket(
  onPaymentReceived,
  onWalletUpdated,
  onTransactionFailed
) {
  const [isConnected, setIsConnected] = useState(false);
  const socketRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem("konnect_token");

    if (!token) {
      console.log("❌ No authentication token found");
      return;
    }

    console.log("🔌 Initializing socket connection...");
    console.log("📍 Socket URL:", `${SOCKET_URL}/delivery`);

    socketRef.current = io(`${SOCKET_URL}/delivery`, {
      auth: {
        token: token,
      },
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });

    socketRef.current.on("connect", () => {
      console.log("✅ Socket connected!");
      console.log("🆔 Socket ID:", socketRef.current.id);
      setIsConnected(true);
    });

    socketRef.current.on("disconnect", (reason) => {
      console.log("❌ Socket disconnected");
      console.log("📋 Reason:", reason);
      setIsConnected(false);
    });

    socketRef.current.on("connect_error", (error) => {
      console.error("⚠️ Connection error:", error.message);
      setIsConnected(false);
    });

    socketRef.current.on("payment:received", (data) => {
      console.log("💰 PAYMENT RECEIVED EVENT");
      console.log("📦 Payment data:", data);
      if (onPaymentReceived) {
        console.log("✓ Calling onPaymentReceived callback");
        onPaymentReceived(data);
      }
    });

    socketRef.current.on("wallet:updated", (data) => {
      console.log("💳 WALLET UPDATED EVENT");
      console.log("📦 Wallet data:", data);
      if (onWalletUpdated) {
        console.log("✓ Calling onWalletUpdated callback");
        onWalletUpdated(data);
      }
    });

    socketRef.current.on("transaction:completed", (data) => {
      console.log("✅ TRANSACTION COMPLETED EVENT");
      console.log("📦 Transaction data:", data);
      if (onPaymentReceived) {
        console.log("✓ Calling transaction completed callback");
        onPaymentReceived(data);
      }
    });

    socketRef.current.on("transaction:failed", (data) => {
      console.log("✅ TRANSACTION FAILED EVENT");
      console.log("📦 Transaction data:", data);
      if (onTransactionFailed) {
        console.log("✓ Calling transaction failed callback");
        onTransactionFailed(data);
      }
    });

    socketRef.current.on("funding:successful", (data) => {
      console.log("💵 FUNDING SUCCESSFUL EVENT");
      console.log("📦 Funding data:", data);
      if (onPaymentReceived) {
        console.log("✓ Calling onPaymentReceived for funding");
        onPaymentReceived(data);
      }
    });

    socketRef.current.onAny((eventName, ...args) => {
      console.log("📨 Received event:", eventName);
      console.log("📦 Event data:", args);
    });

    socketRef.current.on("error", (error) => {
      console.error("⚠️ Socket error:", error);
    });

    return () => {
      console.log("🧹 Cleaning up socket connection");
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [onPaymentReceived, onWalletUpdated, onTransactionFailed]);

  return {
    isConnected,
    socket: socketRef.current,
  };
}
